import React from "react";

function ComputerIcon({ 
  width = 24, 
  height = 24, 
  grayscale = false,
  className = "" 
}) {
  const style = {
    filter: grayscale ? "grayscale(100%)" : "none",
    transition: "filter 0.3s ease",
    width: width,
    height: height
  };

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="90 110 332 260"
      style={style}
      className={className}
    >
      {/* Monitor Frame & Screen */}
      <rect x="96" y="120" width="320" height="200" rx="16" fill="#3A6EA5"/>
      <rect x="112" y="136" width="288" height="168" rx="12" fill="#4F86C6"/>

      {/* Stand & Base */}
      <rect x="220" y="320" width="72" height="24" rx="6" fill="#3A6EA5"/>
      <rect x="200" y="344" width="112" height="16" rx="6" fill="#4F86C6"/>

      {/* Main Content Window - Updated Position */}
      <path 
        d="M160 160 h80 l16 16 h96 a12 12 0 0 1 12 12 v72 a12 12 0 0 1 -12 12 H160 a12 12 0 0 1 -12 -12 v-88 a12 12 0 0 1 12 -12 z"
        fill="#8FB3E0"
      />

      {/* UI Details - Updated to higher positions */}
      <rect x="120" y="125" width="20" height="150" rx="4" fill="#3A6EA5" opacity="0.4"/>
      
      <rect x="175" y="195" width="100" height="6" rx="3" fill="#FFFFFF" opacity="0.6"/>
      <rect x="175" y="210" width="140" height="6" rx="3" fill="#FFFFFF" opacity="0.6"/>
      <rect x="175" y="225" width="60" height="6" rx="3" fill="#FFFFFF" opacity="0.6"/>

      <circle cx="345" cy="190" r="4" fill="#3A6EA5"/>
      <circle cx="330" cy="190" r="4" fill="#3A6EA5"/>

      {/* Top Status Bar */}
      <rect x="112" y="136" width="288" height="15" rx="4" fill="#3A6EA5" opacity="0.3"/>
    </svg>
  );
}

export default ComputerIcon;